import { PostList } from "src/api/client-api/post/types/postList.types";

export type CompletionMetadata = {
    isValid: boolean;
    hasProgress: boolean;
    reference: {
        score: number | undefined;
        label: string | undefined;
    };
    posts: PostList[];
};

type BaseCompletions = {
    weightedAverage: number;
    totalAverageItems: number;
    count: number;
    completedCount: number;
};

type EntityId = number;

export type CompletionsByEntityId = Record<EntityId, BaseCompletions>;

export type Completions = BaseCompletions & {
    byEntityId: CompletionsByEntityId;
};

export type CompletionPost = {
    id: number;
    company?: {
        id: number;
    };
    completions: {
        ssq: {
            result: number;
        };
    };
};

export class CompletionService {
    protected getEmptyBaseCompletions(): BaseCompletions {
        return {
            // Those 2 attributes are linked together
            // That's how you perform weightedAverages
            // Upon weightedAverages
            weightedAverage: 0,
            totalAverageItems: 0,

            count: 0,
            completedCount: 0,
        };
    }

    protected getEmptyCompletions(): Completions {
        const baseCompletions = this.getEmptyBaseCompletions();
        return {
            ...baseCompletions,
            byEntityId: {},
        };
    }

    protected getPostCompletion(post: PostList) {
        return post.completions.ssq;
    }

    protected getPostListCompletion(posts: PostList[]): BaseCompletions {
        const emptyBaseCompletions = this.getEmptyBaseCompletions();

        let grandTotalAverage = 0;
        const completion = posts.reduce<BaseCompletions>((acc, post) => {
            const completion = this.getPostCompletion(post);

            grandTotalAverage += completion.result * completion.questions;
            acc.totalAverageItems += completion.questions;

            if (completion.result === 100) {
                acc.completedCount += 1;
            }
            acc.count += 1;

            return acc;
        }, emptyBaseCompletions);

        if (completion.totalAverageItems > 0) {
            completion.weightedAverage = grandTotalAverage / completion.totalAverageItems;
        }

        return completion;
    }

    public getCompletions(): Completions {
        // Here, we can also decide to either throw an error
        // Or just make sure it has to be declared in the parent for instance

        // Today, I simply make sure it just returns empty data if not overriden
        return this.getEmptyCompletions();
    }
}
